import { render, staticRenderFns } from "./DIVEMetadataSearch.vue?vue&type=template&id=2e06ec9d&scoped=true"
import script from "./DIVEMetadataSearch.vue?vue&type=script&lang=ts"
export * from "./DIVEMetadataSearch.vue?vue&type=script&lang=ts"
import style0 from "./DIVEMetadataSearch.vue?vue&type=style&index=0&id=2e06ec9d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e06ec9d",
  null
  
)

export default component.exports